import { Validator } from 'fluentvalidation-ts';
import { ReceivedMeals } from '@/models';

export class ReceivedMealsSoftValidator extends Validator<ReceivedMeals> {
  constructor() {
    super();

    this.ruleFor('mealDeliveryDateTime')
      .notEmpty()
      .withMessage('There must be a delivery date selected');

    this.ruleFor('mealCountReceived')
      .greaterThan(0)
      .withMessage('Received Meals must contain a count')
      .when(r => r.mealCountLeftoverPrevious == 0);

    this.ruleFor('mealCountLeftoverPrevious')
      .greaterThan(0)
      .withMessage('Leftover Meals must contain a count')
      .when(r => r.mealCountReceived == 0);
  }
}
